import React, { Component } from 'react'
import L from 'leaflet'
const gray = L.icon({
  iconUrl: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSIjNTU1IiBkPSJNMTIgMGMtNC4xOTggMC04IDMuNDAzLTggNy42MDIgMCA0LjE5OCAzLjQ2OSA5LjIxIDggMTYuMzk4IDQuNTMxLTcuMTg4IDgtMTIuMiA4LTE2LjM5OCAwLTQuMTk5LTMuODAxLTcuNjAyLTgtNy42MDJ6bTAgMTFjLTEuNjU3IDAtMy0xLjM0My0zLTNzMS4zNDMtMyAzLTMgMyAxLjM0MyAzIDMtMS4zNDMgMy0zIDN6Ii8+PC9zdmc+Cg==',
  iconSize: [32, 32]
})
const blue = L.icon({
  iconUrl: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSIjNUQ5Q0VDIiBkPSJNMTIgMGMtNC4xOTggMC04IDMuNDAzLTggNy42MDIgMCA0LjE5OCAzLjQ2OSA5LjIxIDggMTYuMzk4IDQuNTMxLTcuMTg4IDgtMTIuMiA4LTE2LjM5OCAwLTQuMTk5LTMuODAxLTcuNjAyLTgtNy42MDJ6bTAgMTFjLTEuNjU3IDAtMy0xLjM0My0zLTNzMS4zNDMtMyAzLTMgMyAxLjM0MyAzIDMtMS4zNDMgMy0zIDN6Ii8+PC9zdmc+Cg==',
  iconSize: [32, 32]
})
const red = L.icon({
  iconUrl: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSIjRTk1NzNGIiBkPSJNMTIgMGMtNC4xOTggMC04IDMuNDAzLTggNy42MDIgMCA0LjE5OCAzLjQ2OSA5LjIxIDggMTYuMzk4IDQuNTMxLTcuMTg4IDgtMTIuMiA4LTE2LjM5OCAwLTQuMTk5LTMuODAxLTcuNjAyLTgtNy42MDJ6bTAgMTFjLTEuNjU3IDAtMy0xLjM0My0zLTNzMS4zNDMtMyAzLTMgMyAxLjM0MyAzIDMtMS4zNDMgMy0zIDN6Ii8+PC9zdmc+Cg==',
  iconSize: [32, 32]
})
const _default = {
  lat: 60.1299967,
  lng: 14.7206008,
  zoom: 6

}
class FlowMap extends Component {
  constructor (props) {
    super(props)
    this.state = {
      error: false
    }
  }
  componentDidMount () {
    try {
      L.latLng(this.props.lat, this.props.lng)
    } catch (err) {
      return this.setState({'error': true})
    }
    this.map = L.map('map', {
      center: [this.props.lat || _default.lat, this.props.lng || _default.lng],
      zoom: this.props.zoom || _default.zoom,
      maxZoom: 17,
      layers: [
        L.tileLayer(this.props.tileServer, {
          attribution: 'Hosted by Maintrac AB &copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors.'
        })
      ]
    })
    if (!this.props.marker) return
    this.marker = L.marker([this.props.lat || _default.lat, this.props.lng || _default.lng], {
      icon: blue,
      draggable: this.props.draggable,
      autoPan: true
    })
    if (this.props.popup) this.marker.bindPopup(this.props.popup)
    this.marker.addTo(this.map)
    if (!this.props.draggable) return
    this.marker.on('dragend', e => {
      var position = e.target.getLatLng()
      if (this.props.onDragEnd) this.props.onDragEnd(position)
    })
  }

  componentWillReceiveProps (nextProps) {
    if (!nextProps.lat || !nextProps.lng) return
    try {
      L.latLng(nextProps.lat, nextProps.lng)
    } catch (err) {
      return this.setState({'error': true})
    }
    if (this.props.lat !== nextProps.lat || this.props.lng !== nextProps.lng) {
      this.marker.setLatLng(L.latLng(nextProps.lat, nextProps.lng))
      this.map.panTo(L.latLng(nextProps.lat, nextProps.lng))
    }
  }

  render () {
    return (
      <div>
        {this.state.error && <div className='alert alert-danger'><i className='fa fa-exclamation-triangle' /> <b>Coordinates could not be parsed.</b></div>}
        <div id='map' style={{ height: this.props.height || 'auto' }} />
      </div>
    )
  }
}
export default FlowMap



// WEBPACK FOOTER //
// ./src/components/basic/displays/FlowMap.js